import { Award01Icon, GiftIcon, LockIcon, Ticket01Icon, UserGroupIcon } from '@hugeicons/react'
import clsx from 'clsx'

import { Badge } from '@/shared/ui/Badge'

import { PRIZE_STATUS_LABELS } from '../constants/status'
import { prizeBadgeVariant } from '../lib/prizeBadgeVariant'

import type { PrizeUiStatus } from '../constants/status'

type PrizeSheetDetailsProps = {
  uiStatus: PrizeUiStatus
  participationHint?: string | null
  eligibleParticipantsLabel?: string | null
}

const hintIconForStatus = (uiStatus: PrizeUiStatus) => {
  if (uiStatus === 'progress') {
    return <Ticket01Icon size={12} variant="duotone" aria-hidden />
  }
  if (uiStatus === 'locked') {
    return <LockIcon size={12} variant="duotone" aria-hidden />
  }
  if (uiStatus === 'success') {
    return <Award01Icon size={12} variant="duotone" aria-hidden />
  }
  if (uiStatus === 'available') {
    return <GiftIcon size={12} variant="duotone" aria-hidden />
  }
  return null
}

export const PrizeSheetDetails = ({
  uiStatus,
  participationHint,
  eligibleParticipantsLabel
}: PrizeSheetDetailsProps) => (
  <div className="mb-5 flex flex-col gap-2">
    <Badge variant={prizeBadgeVariant(uiStatus)} tone="light" showIcon={false}>
      {PRIZE_STATUS_LABELS[uiStatus]}
    </Badge>

    {participationHint && (
      <p
        className={clsx(
          'm-0 flex items-center gap-1.5 text-sm leading-snug',
          uiStatus === 'progress' && 'font-semibold text-primary',
          uiStatus === 'available' && 'text-gray-700',
          uiStatus === 'locked' && 'font-semibold text-gray-700',
          uiStatus === 'success' && 'font-semibold text-status-success',
          uiStatus === 'expired' && 'text-gray-700'
        )}
      >
        {hintIconForStatus(uiStatus)}
        <span>{participationHint}</span>
      </p>
    )}

    {eligibleParticipantsLabel && uiStatus !== 'locked' && (
      <p className="m-0 flex items-center gap-1.5 text-xs text-gray-700">
        <UserGroupIcon size={12} variant="stroke" aria-hidden />
        <span>{eligibleParticipantsLabel}</span>
      </p>
    )}
  </div>
)
